module.exports = __webpack_public_path__ + "StagSans-MediumItalic-Cy-Gr-Web.woff";